export default function MRReportTypeController(
  $q,
  $rootScope,
  $scope,
  ssDialogService,
  loaderService,
  reportsSharedModelService,
  bulkArchiveReportInstancesDialog,
  bulkDeleteReportInstancesDialog,
) {
  const vm = this;

  vm.isExpanded = false;

  vm.hasData = false;

  vm.reportInstances = [];

  vm.numberOfInstances = vm.reportType.numberOfInstances;
  vm.lastGeneratedDate = vm.reportType.lastGeneratedDate;

  vm.showBulkDelete = (vm.numberOfInstances > 0);
  vm.showBulkArchive = (vm.numberOfInstances > 0);

  vm.handleExpandReportType = _handleExpandReportType;
  vm.handleBulkDelete = _handleBulkDelete;
  vm.handleBulkArchive = _handleBulkArchive;

  /** ********************************************
   * Event Handlers
   */

  $scope.$on(`reports.myReports.reportType.reportInstancePublished`, (event, reportInstance) => { 
    const _uniqueId = reportInstance.familyId + '-' + reportInstance.reportId;  
    if (_uniqueId == vm.reportType.uniqueId) {
      _handleRemoveReportInstance(reportInstance);
    }
  });

  $scope.$on(`reports.myReports.reportType.reportInstanceArchived`, (event, reportInstance) => { 
    const _uniqueId = reportInstance.familyId + '-' + reportInstance.reportId;  
    if (_uniqueId == vm.reportType.uniqueId) {
      _handleRemoveReportInstance(reportInstance);
    }
  });

  $scope.$on(`reports.myReports.reportType.reportInstancesArchived`, (event, opt) => { 
    if (opt.uniqueId == vm.reportType.uniqueId) {
      _loadReportInstances();
    }
  });

  $scope.$on(`reports.myReports.reportType.reportInstanceDeleted`, (event, reportInstance) => { 
    const _uniqueId = reportInstance.familyId + '-' + reportInstance.reportId;  
    if (_uniqueId == vm.reportType.uniqueId) {
      _handleRemoveReportInstance(reportInstance);
    }
  });

  $scope.$on(`reports.myReports.reportType.reportInstancesDeleted`, (event, opt) => { 
    if (opt.uniqueId == vm.reportType.uniqueId) {
      _loadReportInstances();
    }
  });

  function _handleExpandReportType() {
    if (vm.isExpanded) {
      vm.isExpanded = false;
      return;
    }

    loaderService.showViewLoader = true;
    _loadReportInstances().then(() => {
      loaderService.showViewLoader = false;
      vm.isExpanded = true;
    });
  }

  function _handleBulkArchive($event) {
    if (!vm.hasData) {
      loaderService.showViewLoader = true;
      _loadReportInstances().then(() => {
          loaderService.showViewLoader = false;
          showBulkArchiveReportInstancesDialog($event);
        });
    } else {
      showBulkArchiveReportInstancesDialog($event);
    }
  }
  
  function showBulkArchiveReportInstancesDialog($event) {
     ssDialogService.dialogs.reports.bulkArchiveReportInstancesDialog = ssDialogService.alert(
      bulkArchiveReportInstancesDialog.getOptions($event, {
        reportType: vm.reportType,
        reportInstances: vm.reportInstances,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.reports.bulkArchiveReportInstancesDialog);
  }

  function _handleBulkDelete($event) {
    if (!vm.hasData) {
      loaderService.showViewLoader = true;
      _loadReportInstances().then(() => {
          loaderService.showViewLoader = false;
          showBulkDeleteReportInstancesDialog($event);
        });
    } else {
      showBulkDeleteReportInstancesDialog($event);
    }
  }

  function showBulkDeleteReportInstancesDialog($event) {
     ssDialogService.dialogs.reports.bulkDeleteReportInstancesDialog = ssDialogService.alert(
      bulkDeleteReportInstancesDialog.getOptions($event, {
        reportType: vm.reportType,
        reportInstances: vm.reportInstances,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.reports.bulkDeleteReportInstancesDialog);
  }


  /** ********************************************
   * Private Functions
   */

  function _loadReportInstances() {
    vm.hasData = false;
    return reportsSharedModelService.getMyReportInstances(vm.reportType.uniqueId, true)
      .then((reportInstances) => {
        vm.reportInstances = [...reportInstances];
        vm.numberOfInstances = vm.reportInstances.length;
        _updateReportInstanceCounts();
        if (vm.reportInstances.length > 0) {
          vm.hasData = true;
        } else {
          // This reportType just lost its last reportInstance, so it should be removed
          $rootScope.$broadcast('reports.myReports.reportTypeEmpty', vm.reportType);
          return;
        }
      });
  }

  function _handleRemoveReportInstance(reportInstance) {
    if (!reportInstance) {
      return;
    }

    if (vm.reportInstances.length <= 1) {
      // This reportType just lost its last reportInstance, so it should be removed
      $rootScope.$broadcast('reports.myReports.reportTypeEmpty', vm.reportType);
      return;
    }
    
    _remove(vm.reportInstances);

    function _remove(collection) {
      const pos = collection.findIndex(item => item.reportInstanceId === reportInstance.reportInstanceId);
      if (pos === -1) {
        return; // Can't find the item
      }
      collection.splice(pos, 1);
    }

    // Update summary info
    vm.numberOfInstances = vm.reportInstances.length;
    vm.reportType.numberOfInstances = vm.reportInstances.length;
    vm.lastGeneratedDate = _getMaxDate(vm.reportInstances);
  }

  function _getMaxDate(reportInstances) {
    let maxDate = reportInstances[0].createDate;
    let maxDateObj = new Date(reportInstances[0].createDate);
    reportInstances.forEach((instance) => {
      if (new Date(instance.createDate) > maxDateObj) {
        maxDate = instance.createDate;
        maxDateObj = new Date(instance.createDate);
      }
    });
    return maxDate;
  }

  function _updateReportInstanceCounts() {
    vm.numberOfInstances = vm.reportInstances.length;
    vm.reportType.numberOfInstances = vm.reportInstances.length;
  }
}

MRReportTypeController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'ssDialogService',
  'loaderService',
  'reportsSharedModelService',
  'bulkArchiveReportInstancesDialog',
  'bulkDeleteReportInstancesDialog',
];
